var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare64BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M49.5 51a1.5 1.5 0 0 0 1.5-1.5v-19a1.5 1.5 0 0 0-1.5-1.5h-19a1.5 1.5 0 0 0-1.5 1.5v19a1.5 1.5 0 0 0 1.5 1.5h19Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.5 39.5A2.5 2.5 0 0 0 20 37V25.5a2.5 2.5 0 0 0-2.5-2.5h-10A2.5 2.5 0 0 0 5 25.5v14h12.5ZM40.5 17.5A2.5 2.5 0 0 0 43 20h11.5a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 54.5 5h-14v12.5ZM17.5 57a2.5 2.5 0 0 0 2.5-2.5V43a2.5 2.5 0 0 0-2.5-2.5H5v14A2.5 2.5 0 0 0 7.5 57h10ZM23 17.5a2.5 2.5 0 0 0 2.5 2.5H37a2.5 2.5 0 0 0 2.5-2.5V5h-14A2.5 2.5 0 0 0 23 7.5v10Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M15 57H7.5A2.5 2.5 0 0 1 5 54.5v-29A2.5 2.5 0 0 1 7.5 23H15M23 15V7.5A2.5 2.5 0 0 1 25.5 5h29A2.5 2.5 0 0 1 57 7.5V15"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 40,
  r: 7,
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  transform: "rotate(-90 68 40)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 68,
  r: 7,
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  transform: "rotate(-90 40 68)"
})));
SvgSquare64BError.viewBox = '0 0 80 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare64BError);
export default ForwardRef;